import { useModelRoot as t, useViewId as r } from "@multisynq/react";
import { getUserId as u } from "../models/ReactTogetherModel.js";
function s() {
  const e = t(), o = r();
  return !e || !o ? null : u(e, o);
}
export {
  s as default
};
